<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>内容管理</a-breadcrumb-item>
    <a-breadcrumb-item>片库送审</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <!-- 剧名 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">剧名：</a-col>
          <a-col :span="18">
            <a-input v-model:value="nameModel" class="tool-item" placeholder="请输入" />
          </a-col>
        </a-row>
      </a-col>
      <!-- 未送审 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">送审平台：</a-col>
          <a-col :span="18">
            <a-select
              v-model:value="platformType"
              class="tool-item"
              placeholder="请选择"
              allow-clear
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            >
              <a-select-option v-for="item in PlatformList" :key="item.key" :value="item.key">{{ item.text }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 操作按钮 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
      <!-- Cookie 配置 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18">
            <a-button @click="getDramaList" type="primary">刷新状态</a-button>
            <a-button style="margin-left: 16px" @click="touchCookieConfig">平台 Cookie 配置</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 多选组件 -->
  <!-- <TableCheckbox
    sourceKey="id"
    :dataSource="dataSource"
    :selectedRowKeys="selectedRowKeys"
    :selectedRows="selectedRows"
    :pagination="pagination"
    :isLoading="isLoading"
  > -->
    <!-- 批量操作按钮 -->
    <!-- <template #checkbox>
      <a-dropdown>
        <template #overlay>
          <a-menu>
            <a-menu-item v-for="item in PlatformList" :key="item.key" @click="touchBatchSubmit(item)">{{ item.text }}</a-menu-item>
          </a-menu>
        </template>
        <a-button style="margin-left: 15px;">批量送审 <DownOutlined /></a-button>
      </a-dropdown>
    </template> -->
    <!-- 列表 -->
    <!-- <a-table
      class="table-view"
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="pagination"
      :loading="isLoading"
      :scroll="{ x: scrollX, y: 'max-content' }"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      @change="handleTableChange"
    > -->
    <a-table
      class="table-view"
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="pagination"
      :loading="isLoading"
      :scroll="{ x: scrollX, y: 'max-content' }"
      @change="handleTableChange"
    >
      <template #bodyCell="{ column, record }">
        <!-- 剧名列 -->
        <template v-if="column.key === 'remark_name'">
          <div>{{ record.remark_name }}</div>
          <div v-if="record.name && record.name !== record.remark_name" style="color: #999;">({{ record.name }})</div>
        </template>
        <!-- 平台状态列（动态） -->
        <template v-if="platformKeySet.has(column.key)">
          <!-- UC 平台 -->
          <template v-if="column.key === 'uc'">
            <!-- 进行中、成功、已上线：纯文字，无下拉 -->
            <span
              v-if="[PlatformStatusProcessing, PlatformStatusPassed, PlatformStatusOnline].includes(getPlatformStatus(record, column.key))"
              :style="{ color: getStatusColor(record, column.key), whiteSpace: 'nowrap' }"
            >
              {{ getStatusText(record, column.key) }}
            </span>
            <!-- 待提审、失败、空状态：hover 下拉 -->
            <a-dropdown
              v-else
              :trigger="['hover']"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            >
              <span :style="{
                color: getPlatformStatus(record, column.key) ? getStatusColor(record, column.key) : '#bfbfbf',
                cursor: 'pointer',
                whiteSpace: 'nowrap'
              }">
                {{ getPlatformStatus(record, column.key) ? getStatusText(record, column.key) : '-' }}
                <DownOutlined v-if="getPlatformStatus(record, column.key)" style="font-size: 11px" />
              </span>
              <template #overlay>
                <a-menu>
                  <a-menu-item v-if="!getPlatformDramaId(record, column.key)" @click="touchUcEdit(record)">编辑信息</a-menu-item>
                  <a-menu-item @click="touchPlatformOp(record, column.key, 'review')">短剧送审</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
          <!-- 其他平台（暂无操作，后续按平台添加） -->
          <template v-else>
            <span :style="{ color: getStatusColor(record, column.key), whiteSpace: 'nowrap' }">
              {{ getPlatformStatus(record, column.key) ? getStatusText(record, column.key) : '-' }}
            </span>
          </template>
        </template>
        <!-- 操作列 -->
        <template v-else-if="column.key === 'operation'">
          <a class="operation-item" @click="touchInfo(record)">基本信息</a>
        </template>
      </template>
    </a-table>
  <!-- </TableCheckbox> -->
  <!-- 基本信息抽屉 -->
  <NewFilmDrawer ref="RefNewFilmDrawer" @success="getDramaList"></NewFilmDrawer>
  <!-- UC 编辑抽屉 -->
  <UcEditDrawer ref="RefUcEditModal" @success="getDramaList"></UcEditDrawer>
  <!-- Cookie 配置抽屉 -->
  <CookieConfigDrawer ref="RefCookieConfigDrawer"></CookieConfigDrawer>
</template>

<script setup>
import { onBeforeMount, reactive, ref, computed } from 'vue'
// import TableCheckbox from '@/components/TableCheckbox'
import NewFilmDrawer from './components-film-library/NewFilmDrawer'
import UcEditDrawer from './components-film-library-audit/UcEditDrawer'
import CookieConfigDrawer from './components-film-library-audit/CookieConfigDrawer'
import { message, Modal } from 'ant-design-vue'
import { thirdDramaList } from '@/api/copyright'
import { autoTaskRun } from '@/api/autoFilmLibrary'
import {
  PlatformAuditStatusOnline,
  PlatformAuditStatusPassed,
  PlatformAuditStatusProcessing,
  PlatformAuditStatusFailed,
  PlatformAuditStatusList,
  ThirdPlatformList
} from '@/utils/constantFilmLibrary'

// 平台 key 集合（用于 bodyCell 快速判断）
const platformKeySet = new Set(ThirdPlatformList.map(p => p.key))

// 平台列表和平台状态直接使用导入名
const PlatformList = ThirdPlatformList
const PlatformStatusOnline = PlatformAuditStatusOnline
const PlatformStatusPassed = PlatformAuditStatusPassed
const PlatformStatusProcessing = PlatformAuditStatusProcessing
const PlatformStatusFailed = PlatformAuditStatusFailed
const PlatformAuditStatus = PlatformAuditStatusList

// ========================= 工具函数 =========================
function getPlatformByKey(key) {
  return PlatformList.find(p => p.key === key)
}

function getPlatformStatus(record, key) {
  const platform = getPlatformByKey(key)
  return platform ? record[platform.statusField] : null
}

function getPlatformDramaId(record, key) {
  const platform = getPlatformByKey(key)
  return platform ? record[platform.idField] : null
}

function getStatusText(record, key) {
  const status = getPlatformStatus(record, key)
  const item = PlatformAuditStatus.find(s => s.value === status)
  return item ? item.text : '-'
}

function getStatusColor(record, key) {
  const status = getPlatformStatus(record, key)
  const item = PlatformAuditStatus.find(s => s.value === status)
  return item ? item.color : ''
}

// ========================= Refs =========================
let RefNewFilmDrawer = ref(null)
let RefUcEditModal = ref(null)
let RefCookieConfigDrawer = ref(null)

// 搜索
let nameModel = ref(undefined)
let name = ref(undefined)
let platformType = ref(undefined)

// 加载
let isLoading = ref(false)

// 多选
let selectedRowKeys = ref([])
let selectedRows = ref([])

// 数据
let dataSource = ref([])

// 滚动宽度
let scrollX = ref(0)

// 分页
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})

// ========================= 列配置（动态） =========================
const columns = computed(() => {
  const platformCols = PlatformList.map(p => ({
    title: p.text,
    dataIndex: p.statusField,
    key: p.key,
    width: 120
  }))
  return [
    { title: '剧名', dataIndex: 'remark_name', key: 'remark_name', fixed: 'left', width: 200 },
    ...platformCols,
    { title: '操作', dataIndex: 'operation', key: 'operation', fixed: 'right', width: 100 }
  ]
})

// ========================= 生命周期 =========================
onBeforeMount(() => {
  touchSearch()
  // 计算滚动宽度
  scrollX.value = 200 + PlatformList.length * 120 + 100
})

// ========================= 事件处理 =========================
function handleTableChange(p) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getDramaList()
}

function onSelectChange(rowKeys, rows) {
  selectedRowKeys.value = rowKeys
  selectedRows.value = rows
}

function touchSearch() {
  name.value = nameModel.value
  pagination.current = 1
  getDramaList()
}

function touchReset() {
  nameModel.value = undefined
  name.value = undefined
  platformType.value = undefined
  touchSearch()
}

// 基本信息
function touchInfo(record) {
  RefNewFilmDrawer.value.showDrawer(record)
}

// Cookie 配置
function touchCookieConfig() {
  RefCookieConfigDrawer.value.show()
}

// UC 编辑信息
function touchUcEdit(record) {
  RefUcEditModal.value.show(record)
}

// 平台操作（各平台具体操作，可根据后端接口完善）
function touchPlatformOp(record, platformKey, opType) {
  if (opType === 'review') {
    touchReview(record, platformKey)
    return
  }
  const platform = getPlatformByKey(platformKey)
  const opMap = {
    create: '创建短剧',
    edit: '编辑信息',
    bind: '绑定剧集',
    launch: '剧目上线',
    supplement: '补充信息',
    resubmit: '一键提交'
  }
  const opText = opMap[opType] || opType
  message.info(`【${platform ? platform.text : platformKey}】${opText} - 功能开发中`)
}

// 短剧送审
function touchReview(record, platformKey) {
  const platform = getPlatformByKey(platformKey)
  Modal.confirm({
    title: '短剧送审',
    content: `确定要将「${record.name}」送审到「${platform ? platform.text : platformKey}」平台？`,
    cancelText: '取 消',
    okText: '确 定',
    onOk: () => {
      isLoading.value = true
      autoTaskRun({ id: record.id, platform: platformKey }).then(res => {
        isLoading.value = false
        if (res.code === 0) {
          message.success('送审进行中')
        } else {
          message.error(res.msg || res.message || '送审失败')
        }
        getDramaList()
      }).catch(() => {
        isLoading.value = false
        message.error('送审失败')
        getDramaList()
      })
    }
  })
}

// 批量送审
function touchBatchSubmit(platform) {
  if (!selectedRowKeys.value.length) {
    message.error('请选择影剧')
    return
  }
  Modal.confirm({
    title: '批量送审',
    content: `确定要将选中的 ${selectedRowKeys.value.length} 部影剧批量送审到「${platform.text}」平台？`,
    cancelText: '取 消',
    okText: '确 定',
    onOk: () => {
      message.info('功能开发中')
    }
  })
}

// ========================= 接口 =========================
function getDramaList() {
  isLoading.value = true
  const params = {
    name: name.value,
    type: platformType.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  thirdDramaList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
      selectedRowKeys.value = []
      selectedRows.value = []
    } else {
      message.error(res.msg || res.message || '获取列表失败')
    }
  }).catch(() => {
    isLoading.value = false
  })
}
</script>

<style scoped>
</style>
